import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`${`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-white py-4'}`} pt-[10px] pb-[10px]`} data-id="element-296">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center" data-id="element-297">
        <a href="#" className="flex items-center" aria-label="Bitzen eCommerce" data-id="element-298">
          <img src="https://cdn.magicpatterns.com/uploads/kg43cwPFsTeJ6gPr67eY8G/Bitzen-logo-Final_350.png" alt="Bitzen eCommerce" className="h-9 md:h-10 w-auto" data-id="element-299" />
        </a>
      </div>
    </nav>;
}